import OntologyIcon from '../core/icons/Ontology';
import ResourceLink from '../core/ResourceLink';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { APPLICATION_PATHS } from '../application-core/constants';
import ExternalResourceLink from '../core/ExternalResourceLink';
import { globalStyles as styles } from '../core/style/gstheme';
import withGS from '../core/withGShoc';
import SchemeChip from '../vocabulary/core/SchemeChip';

const loadOptions = {};

class ResourceIriDisplay extends React.Component {

  buildLink = (resourceData) => {
    const ontology = resourceData.visibility || resourceData.isDefinedBy;
    if (!ontology) return null;
    let view = "class";
    if (resourceData.type.includes("ObjectProperty")) {
      view = "objectProperty";
    }
    else if (resourceData.type.includes("DatatypeProperty")) {
      view = "datatypeProperty";
    }
    else if (resourceData.type.includes("AnnotationProperty")) {
      view = "annotationProperty";
    }

    let link = APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/ontology#project=' +
      this.props.projectIRI + "&ontology=" + ontology + "&view=" + view + "&" + view + "=" + resourceData.id;
    return link;
  };

  render() {

    const { data, id, defaultLang, viewLang, graph, projectIRI, property, source, onLink, context, wrap, compact } = this.props;

    const isNotLoaded = data._notAvailable;
    const isInFocus = data.isDefinedBy || data.visibility ? true : false;

    let output;
    if (!isInFocus && data.type === "Ontology") {
      output = <SchemeChip key={data.id}
        id={data.id}
        viewLang={viewLang}
        link={APPLICATION_PATHS.ONTOLOGY_MANAGER + '/project/ontology#project=' + projectIRI + "&ontology=" + data.id}
        onLink={onLink}
        defaultLang={defaultLang}
        isReadOnly={true}
        graph={graph}
        avatar={<OntologyIcon data-test="ontology-icon" fontSize="small" />}
        project={projectIRI} />;
    }
    else if (!isNotLoaded) {
      output = <ResourceLink
        id={id}
        graph={graph}
        projectGraph={graph}
        link={this.buildLink}
        compact={compact}
        onLink={onLink}
        context={context}
        contextProperty="isDefinedBy"
        isReadOnly={true}
        source={source}
        property={property}
        viewLang={viewLang}
        defaultLang={defaultLang} />;
    }
    else if (isNotLoaded) {
      output = <ExternalResourceLink
        id={id}
        graph={graph}
        isReadOnly={true} />;
    }
    else {
      return null;
    }

    return (
      wrap ?
        <div style={{ maxWidth: '100%' }}>
          {output}
        </div>
        :
        output
    );
  }
}

ResourceIriDisplay.defaultProps = {
  wrap: true,
  compact: false
};

ResourceIriDisplay.propTypes = {
  isLoading: PropTypes.bool,
  compact: PropTypes.bool,
  source: PropTypes.string,
  property: PropTypes.string,
  propertyGraph: PropTypes.string,
  graph: PropTypes.string.isRequired,
  onLink: PropTypes.func,
  components: PropTypes.array,
  context: PropTypes.string,
  wrap: PropTypes.bool,
  defaultLang: PropTypes.string.isRequired,
  viewLang: PropTypes.string,
  projectIRI: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(ResourceIriDisplay, ["ALL"], null, loadOptions, true));